import { render, staticRenderFns } from "./ConfigContaView.vue?vue&type=template&id=34729e70&"
import script from "./ConfigContaView.vue?vue&type=script&lang=js&"
export * from "./ConfigContaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports